<template>
    <div>
        <Head :title="__('Workplaces')" />

        <h1 class="mb-8 text-3xl font-bold">{{ __('Workplace') }} {{ workplace }}</h1>

        <p class="mb-8 leading-normal">
            Här kan du se och ta bort alla ordrar som är kopplade till {{ workplace }}.
        </p>

        <div class="mb-8">

        </div>

        <div class="overflow-x-auto bg-white rounded-md shadow">
            <table class="w-full whitespace-nowrap">
                <tr class="font-bold text-left">
                    <th class="px-6 pt-6 pb-4">  </th>
                    <th class="px-6 pt-6 pb-4"> {{ __('Date') }} </th>
                    <th class="px-6 pt-6 pb-4"> Beställare </th>
                    <th class="px-6 pt-6 pb-4"> {{ __('Phone') }} </th>
                    <th class="px-6 pt-6 pb-4"> {{ __('Address') }} </th>
                    <th class="px-6 pt-6 pb-4"> {{ __('Zip / Postal Code') }} </th>
                    <th class="px-6 pt-6 pb-4"> {{ __('City') }} </th>
                    <th class="px-6 pt-6 pb-4"> {{ __('Order no') }} </th>
                </tr>

                <tr class="border-b border-gray-200" v-for="order in orders.data" v-bind:key="order.id">
                    <td class="px-6 py-4">
                        <input
                            v-if="!order.deleted_at"
                            type="checkbox"
                            class="text-red-600 hover:underline"
                            @change="checkDelete(order.id)"
                            tabindex="-1"
                        />
                    </td>
                    <td class="px-6 py-4">{{order.created_at.substr(0,10)}}</td>
                    <td class="px-6 py-4">{{order.client.name}}</td>
                    <td class="px-6 py-4">{{order.client.phone}}</td>
                    <td class="px-6 py-4">{{order.street_address}}</td>
                    <td class="px-6 py-4">{{order.zip_code}}</td>
                    <td class="px-6 py-4">{{order.city}}</td>
                    <td class="px-6 py-4"><Link :href="`/orders/${order.id}`">{{order.id}}</Link></td>
                </tr>
            </table>
        </div>
        <button
            v-if="deleteOrders.length > 0"
            type="button"
            class="px-4 py-3 my-1 mr-1 text-sm leading-4 text-white bg-red-600 border rounded blockpx-4 hover:bg-red-400"
            tabindex="-1"
            @click="destroy()"
        >
            {{ __('Delete') }}
        </button>
    </div>
</template>

<script>
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import Layout         from '@/Shared/Layout'

    export default {
        components: {
            Head,
            Link,
        },
        layout: Layout,
        data: () => ({
            searchTimeout: null,
            search: '',
            deleteOrders: []
        }),
        props: {
            clients: Array,
            orders: Object,
            workplace: String,
            // pagination: { // Does this need pagination?
            //     type: Object,
            //     required: true
            // }
        },
        computed: {
        },
        methods: {
            checkDelete(id) {
                // add id if input is checked and remove if not
                if(this.deleteOrders.includes(id)) {
                    this.deleteOrders.splice(this.deleteOrders.indexOf(id), 1);
                } else {
                    this.deleteOrders.push(id);
                }
            },
            destroy() {
                if (confirm('Ta bort valda ordrar?')) {
                    this.$inertia.delete(`/orders-multiple/${this.workplace}`, {
                        data: {
                            orders: this.deleteOrders
                        }
                    }, {preserveState: true, preserveScroll: true});
                }
            },
        }
    }
</script>
